import { AssistantResource, AssistantResourceState } from '@mews-commander/data-access';
import { IconName, Tag, TagVariant } from '@optimus-web/core';
import { useResolveRoute } from '@mews/routing';
import { RouteName } from '@mews-commander/enums';
import { LocalizedEnum } from '@mews/framework';
import { ResultListProps } from '../results/ListTitle';
import { highlight } from '../../utils/highlight';
import { navigateInBaseModal } from '../../../app/actions/common';
import { StyledLeftIcon } from '../styles';
import { SearchType } from '../../assistantSearchTypes';
import { AssistantSearchListItemProps } from './useAssistantSearchResultListMap';

interface ResourceListProps extends ResultListProps {
    resources: AssistantResource[];
}
const getPrimaryText = (resource: AssistantResource): string => (resource.name ? resource.name : '');

interface RightItemProps {
    state?: AssistantResourceState;
}

const tagVariants: Record<AssistantResourceState, TagVariant> = {
    [AssistantResourceState.Clean]: 'denim',
    [AssistantResourceState.Dirty]: 'tangerine',
    [AssistantResourceState.Inspected]: 'lime',
    [AssistantResourceState.OutOfOrder]: 'mustard',
    [AssistantResourceState.OutOfService]: 'ruby',
};
const RightItem = ({ state }: RightItemProps) => {
    if (!state) {
        return null;
    }

    const variant = tagVariants[state];

    return (
        <Tag variant={variant}>
            <LocalizedEnum prefix="ResourceState" value={state} />
        </Tag>
    );
};

export const useResourceList = ({ resources, searchTerm }: ResourceListProps): AssistantSearchListItemProps[] => {
    const resolveRoute = useResolveRoute();

    return resources.map((resource) => {
        const url = resolveRoute(RouteName.ResourceDetail, { id: resource.id });
        const rightItem = <RightItem state={resource.state} />;
        return {
            itemId: resource.id || '',
            primaryText: highlight(getPrimaryText(resource), searchTerm),
            rightItem,
            leftIcon: <StyledLeftIcon size="small" value={IconName.Room} />,
            routeAction: navigateInBaseModal(url),
            searchType: SearchType.Resource,
        };
    });
};
